import { createZodDto } from 'nestjs-zod/dto';
import { ServiceAccountMemberCreateSchema } from '#web-service-api/member';
import { CommonInvitationCreateSchema } from './common-invitation-create.schema';
export const ServiceAccountInvitationCreateSchema = CommonInvitationCreateSchema.extend({
    member: ServiceAccountMemberCreateSchema,
});
export class ServiceAccountInvitationCreateDto extends createZodDto(ServiceAccountInvitationCreateSchema) {
}
